import { render, staticRenderFns } from "./PatronCard.vue?vue&type=template&id=770b28f0&scoped=true"
import script from "./PatronCard.vue?vue&type=script&lang=js"
export * from "./PatronCard.vue?vue&type=script&lang=js"
import style0 from "./PatronCard.vue?vue&type=style&index=0&id=770b28f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770b28f0",
  null
  
)

export default component.exports